import store from '../store';
import utils from './utils';
import { UnleashClient } from 'unleash-proxy-client';

const unleashConfig = {
  development: {
    clientKey: 'HgjLg4OuawmoxleUHCvxCvptjEBgtt7r',
    environment: 'development',
    url: 'https://us.app.unleash-hosted.com/uscc1004/api/development/proxy',
  },
  production: {
    clientKey: 'wLOq4eztJMk6JRctaiCqDnciahET24Ma',
    environment: 'production',
    url: 'https://us.app.unleash-hosted.com/uscc1004/api/production/proxy',
  },
};

const { clientKey, environment, url } = utils.isProduction()
  ? unleashConfig.production
  : unleashConfig.development;

const unleash = new UnleashClient({
  appName: 'mikmak-dashboard',
  clientKey,
  environment,
  url,
});

// Custom method to prevent error when calling unleash.start() multiple times.
// Is invoked when navigating between our microfrontends,
// because mounting and unmounting occurs regularly.
unleash.init = () => {
  if (!unleash.timerRef) unleash.start();
};

unleash.on('update', () => {
  const toggles = unleash.getAllToggles() || [];

  store.dispatch('setFeatureFlags', toggles);
});

export { unleash };
